import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import DBInput from "../../../../component/global/DBInput";
import DBModalTitle from "../../../../component/global/DbModalTitle";
import DBFieldBlock from "../../../../component/global/DBFieldBlock";
import TreeSearchSelect from "./../../../../component/global/TreeSearchSelect/index";
import DBSelect from "../../../../component/global/DBSelect";
import DBButton from "../../../../component/global/DBButton";
import DBTextArea from "../../../../component/global/DBTextArea";
import { useContext, useEffect, useRef, useState } from "react";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import {
    GET_AUTOMATION_GROUP_LIST,
    SETTING_FEATURES,
    SETTING_FEATURES_LIST,
    SETTING_ITEMS_TYPE,
    SETTING_ITEMS_TYPE_FAETURES,
    SETTING_ITEMS_TYPE_TREE,
} from "../../../../helperData/ApiAddress";
import DBSpinner from "../../../../component/global/DBSpinner";
import DBAddButton from "../../../../component/global/DBAddButton";
import { ToastContext } from "../../../../component/global/ToastContext";
import DBSwitch from "./../../../../component/global/DBSwitch/index";
import { featureTypeList, toBase64 } from "../../../../feedback/helperFunctions";
import DBAutoComplete from "../../../../component/global/DBAutoComplete";
import DBUpload from "../../../../component/global/DBUpload";

const FEATURE_TYPE_FILE = 2;
const FEATURE_TYPE_IMAGE = 3;

const emptyFeatureForm = (itemTypeId) => ({
    feature: {
        name: "",
        feature_type: 1,
        language: "fa",
        feature_level: 1,
    },
    item_type: itemTypeId,
    show_on_print: true,
    show_priority: "1",
    show_to_all: true,
    is_fixed: false,
    fixed_value: "",
});

export default function FeaturesModal({
    showModal,
    onHide,
    onSuccess,
    editMode,
    itemType,
}) {
    const toast = useContext(ToastContext);

    const [form, setForm] = useState(emptyFeatureForm(itemType?.id));

    const [formErr, setFormErr] = useState({
        name: "",
        show_priority: "",
        fixed_value: "",
    });

    const [sendFeature, sendFeatureLoader] = useRequest(
        SETTING_ITEMS_TYPE_FAETURES + (editMode ? `${editMode}/` : ""),
        editMode ? "PUT" : "POST"
    );

    const [getFeatureList, getFeatureListLoader] = useRequest(
        SETTING_FEATURES_LIST,
        "GET"
    );

    const [getFeature, getFeatureLoader] = useRequest(
        SETTING_ITEMS_TYPE_FAETURES + editMode + "/",
        "GET"
    );
    const [featureList, setFeatureList] = useState([]);
    const getFeatureListHandle = () => {
        getFeatureList({
            feature_level: 1,
        }).then((r) => {
            setFeatureList(
                r.map((item) => ({
                    label: item.name,
                    id: item.id,
                    value: item.name + item.id,
                }))
            );
        });
    };

    const isFileLikeType =
        form.feature.feature_type === FEATURE_TYPE_FILE ||
        form.feature.feature_type === FEATURE_TYPE_IMAGE;

    useEffect(() => {
        if (showModal) {
            getFeatureListHandle();
            if (editMode) {
                getFeature().then((r) => {
                    setForm({
                        feature: {
                            id: r.feature,
                            name: r.name,
                            label: r.name,
                            feature_type: r.feature_type,
                            language: r.language,
                            feature_level: 1,
                        },
                        item_type: r.item_type,
                        show_on_print: true,
                        show_priority: r.show_priority + "",
                        show_to_all: r.show_to_all,
                        is_fixed: !!r.is_fixed,
                        fixed_value: r.fixed_value || "",
                    });
                });
            } else {
                setForm(emptyFeatureForm(itemType?.id));
            }

            setFormErr({
                name: "",
                show_priority: "",
                fixed_value: "",
            });
        }
    }, [showModal]);

    const setFeatureType = (featureType) => {
        const nextIsFileLike =
            featureType === FEATURE_TYPE_FILE ||
            featureType === FEATURE_TYPE_IMAGE;
        setForm({
            ...form,
            feature: {
                ...form.feature,
                feature_type: featureType,
            },
            is_fixed: nextIsFileLike ? form.is_fixed : false,
            fixed_value: nextIsFileLike ? form.fixed_value : "",
        });
        setFormErr({ ...formErr, fixed_value: "" });
    };

    const addEditFeature = () => {
        let formErrTemp = {};

        if (form.feature.label.trim() === "") {
            formErrTemp = { ...formErrTemp, name: t("features.name.required") };
        }
        if (form.show_priority.trim() === "") {
            formErrTemp = {
                ...formErrTemp,
                show_priority: t("features.weight.required"),
            };
        }
        if (isFileLikeType && form.is_fixed && !form.fixed_value) {
            formErrTemp = {
                ...formErrTemp,
                fixed_value: t("features.fixed.file.required"),
            };
        }

        setFormErr(formErrTemp);

        if (Object.keys(formErrTemp).length > 0) return false;

        sendFeature({
            ...form,
            is_fixed: isFileLikeType ? form.is_fixed : false,
            fixed_value:
                isFileLikeType && form.is_fixed ? form.fixed_value : null,
            feature: form.feature.id || {
                ...form.feature,
                feature_type: form.feature.feature_type,
                language: form.feature.language,
            },
        })
            .then((r) => {
                onHide?.();
                onSuccess?.();
                toast(t("features.save.success"), "success");
            })
            .catch((e) => {
                toast(t("features.save.error"), "danger");
            });
    };

    return (
        <DBModal
            permanent
            show={showModal}
            minWidth={560}
            onHide={onHide}
            className="features-modal"
        >
            <DBModal.Header closeBtn={onHide} title={t("create.feature")} />

            <DBModal.Content>
                {getFeatureLoader || getFeatureListLoader ? (
                    <DBSpinner tip={t("loading")} />
                ) : (
                    <>
                        <DBModalTitle>
                            {t("item.type.main.fields")}
                        </DBModalTitle>
                        <div className="grid">
                            <DBFieldBlock
                                title={t("features.name")}
                                required
                                error={formErr.name}
                            >
                                <DBAutoComplete
                                    onClick={() =>
                                        setFormErr({ ...formErr, name: "" })
                                    }
                                    exactMatch={(option) => {
                                        setForm({
                                            ...form,
                                            feature: option,
                                        });
                                    }}
                                    status={formErr.name && "error"}
                                    onChange={(caption, option) => {
                                        let temp = { ...form.feature };

                                        if (option.value) {
                                            temp = option;
                                        } else {
                                            temp = {
                                                name: caption,
                                                label: caption,
                                                value: caption,
                                                id: undefined,
                                            };
                                        }
                                        setForm({
                                            ...form,
                                            feature: {
                                                ...form.feature,
                                                ...temp,
                                            },
                                        });
                                    }}
                                    onLock={(caption, option) => {
                                        let temp = { ...form.feature };
                                        temp = option;
                                        setForm({
                                            ...form,
                                            feature: {
                                                ...form.feature,
                                                ...temp,
                                            },
                                        });
                                    }}
                                    options={featureList}
                                    value={form.feature?.label}
                                />
                            </DBFieldBlock>
                            <DBFieldBlock title={t("features.type")} required>
                                <DBSelect
                                    disabled={form.feature.id}
                                    value={form.feature.feature_type}
                                    onChange={setFeatureType}
                                    options={featureTypeList
                                        .filter((item) => item !== null)
                                        .map((item, index) => ({
                                            value: index + 1,
                                            label: item,
                                        }))
                                        .filter((_, index) => index !== 2)}
                                    size="large"
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("features.language")}
                                required
                            >
                                <DBSelect
                                    disabled={form.feature.id}
                                    value={form.feature.language}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            feature: {
                                                ...form.feature,
                                                language: e,
                                            },
                                        })
                                    }
                                    options={[
                                        {
                                            value: "fa",
                                            label: t("item.type.language.fa"),
                                        },
                                        {
                                            value: "en",
                                            label: t("item.type.language.en"),
                                        },
                                        {
                                            value: "ar",
                                            label: t("item.type.language.ar"),
                                        },
                                    ]}
                                    size="large"
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("features.weight")}
                                required
                                error={formErr.show_priority}
                            >
                                <DBInput
                                    onClick={() =>
                                        setFormErr({
                                            ...formErr,
                                            show_priority: "",
                                        })
                                    }
                                    status={formErr.show_priority && "error"}
                                    type="number"
                                    size="large"
                                    value={form.show_priority}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            show_priority: e.target.value,
                                        })
                                    }
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("features.show.all")}
                                required
                            >
                                <div className="features-switch-container">
                                    <DBSwitch
                                        checked={form.show_to_all}
                                        onChange={(e) =>
                                            setForm({ ...form, show_to_all: e })
                                        }
                                    />
                                </div>
                            </DBFieldBlock>
                            {isFileLikeType && (
                                <DBFieldBlock
                                    title={t("features.fixed.file.question")}
                                    required
                                >
                                    <div className="features-switch-container">
                                        <DBSwitch
                                            checked={form.is_fixed}
                                            onChange={(e) =>
                                                setForm({
                                                    ...form,
                                                    is_fixed: e,
                                                    fixed_value: e
                                                        ? form.fixed_value
                                                        : "",
                                                })
                                            }
                                        />
                                    </div>
                                </DBFieldBlock>
                            )}
                            {isFileLikeType && form.is_fixed && (
                                <DBFieldBlock
                                    title={t("features.fixed.file.upload")}
                                    required
                                    error={formErr.fixed_value}
                                    span={2}
                                >
                                    <DBUpload
                                        accept={
                                            form.feature.feature_type ===
                                            FEATURE_TYPE_IMAGE
                                                ? ".jpg,.jpeg,.png"
                                                : ".jpg,.jpeg,.pdf,.zip"
                                        }
                                        maxSize={1024 * 1024}
                                        outlined
                                        caption={
                                            form.fixed_value
                                                ? t("feature.file.delete")
                                                : t("feature.file.upload")
                                        }
                                        type={
                                            form.fixed_value
                                                ? "secondary"
                                                : "primary"
                                        }
                                        onClick={(e) => {
                                            if (form.fixed_value) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                setForm({
                                                    ...form,
                                                    fixed_value: "",
                                                });
                                            }
                                        }}
                                        onChange={async (e) => {
                                            setFormErr({
                                                ...formErr,
                                                fixed_value: "",
                                            });
                                            setForm({
                                                ...form,
                                                fixed_value: await toBase64(
                                                    e.target.files[0]
                                                ),
                                            });
                                        }}
                                    />
                                </DBFieldBlock>
                            )}
                        </div>
                    </>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("save")}
                    onClick={addEditFeature}
                    loading={sendFeatureLoader}
                />
                <DBButton
                    caption={t("cancel")}
                    type="secondary"
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
